import { inject } from 'inversify';

import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { appendToFormData, urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { TopupSettingsDto } from '../dtos';
import { SettingsMapper } from '../mappers';

export type IUpdateTopupSettingsRepoResponse = IRepoResponse<200, string> | IRepoResponse<400 | 500, string> | IRepoResponse<422, Record<string, string>>;

export type IUpdateTopupSettingsRepo = IRepo<[TopupSettingsDto], IUpdateTopupSettingsRepoResponse>;

export const UpdateTopupSettingsRepoType = Symbol.for('UpdateTopupSettingsRepo');

@bind(UpdateTopupSettingsRepoType)
export class UpdateTopupSettingsRepo implements IUpdateTopupSettingsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(dto: TopupSettingsDto) {
    try {
      const body = new FormData();
      const mappedBody = SettingsMapper.topupSettingsDtoToPersistence(dto);

      appendToFormData(mappedBody, body);

      const url = urlMaker('/api/admin/settings/data', { group_id: 'topup' });

      const result = await this.httpClient.post({ url, body });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: 'Əməliyyat müvəffəqiyyətlə başa çatdı.',
        };
      } else if (result.status === 422) {
        return {
          status: 422 as 422,
          response: result.data.errors,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar yadda saxlanıla bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
